module.exports = __webpack_public_path__ + "static/media/logo_clinicaalaquas.7798e432.png";